import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";

@Injectable()
export class SettingsService {
  constructor(private authorizedService: AuthorizedService) {
  }

  get() {
    return this.authorizedService.get(ServiceConfig.settings.url).map(data => {
      return data.json()
    });
  }

  save(settings: any) {
    return this.authorizedService.post(ServiceConfig.settings.url, settings).map(data => {
      return data.json()
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/settings.service.ts